import React from 'react'
import UserProfileContaner from '../../modules/GAUserProfile/containers/UserProfileContainer/UserProfileContainer'

export default function GAUserProfile() {
  return (
    <div>
        <UserProfileContaner />
    </div>
  )
}
